import { render, staticRenderFns } from "./OrderViews.vue?vue&type=template&id=c701b15a&lang=pug&"
import script from "./OrderViews.vue?vue&type=script&lang=js&"
export * from "./OrderViews.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports